import { makeUseAccess, makeUseCreateAccess } from '../../../utils/accessControl';
import { HeatmapsRequestActions } from '../actions';
import { getHeatmapAccess } from '../selectors';

export const useHeatmapsAccess = makeUseAccess(HeatmapsRequestActions.getAccess, getHeatmapAccess);

export const useHeatmapsCreateAccess = makeUseCreateAccess(
  HeatmapsRequestActions.getAccess,
  getHeatmapAccess,
);
